import { TableSearch } from "ui/components/Table/TableSearch";
import { TableGrid } from "ui/components/Table/TableGrid";
import { memo, useCallback } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { FLEET_VEHICLE_SEARCH_COLUMNS } from "./consts";
import { VehicleSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import { VehicleGridCard } from "../VehicleGridCard";
import { FleetVehicleRow } from "services/api/fleet/vehicles/types";

const VehicleSearchResults: React.FC<VehicleSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    selectableRows = false,
    viewType = "table",
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  const { t } = useTranslate();

  const renderGridItem = useCallback(
    (vehicle: FleetVehicleRow) => {
      return <VehicleGridCard vehicle={vehicle} onRowClick={onRowClick} />;
    },
    [onRowClick]
  );

  if (viewType === "grid") {
    return (
      <TableGrid
        data={searchResults.data}
        renderItem={renderGridItem}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        onPaginationChange={onPaginationChange}
        isLoading={isLoading}
        selectedItems={selectedRows}
        onSelectedChange={onSelectedChange}
        selectableItems={selectableRows}
      />
    );
  }

  return (
    <TableSearch
      columns={FLEET_VEHICLE_SEARCH_COLUMNS(t)}
      data={searchResults.data}
      selectedRows={selectedRows as unknown as number[]}
      pagination={
        searchResults.pagination || initialDataWithPagination.pagination
      }
      selectableRows={selectableRows}
      onPaginationChange={onPaginationChange}
      onSelectedChange={onSelectedChange as unknown as ((selected: number[] | number) => void) | undefined}
      isLoading={isLoading}
      onRowClick={onRowClick}
      isMinimized={true}
      size="full"
    />
  );
};
export default memo(VehicleSearchResults);
